import { render, staticRenderFns } from "./ClosingPriceHistogram.vue?vue&type=template&id=1cf8c11e&"
import script from "./ClosingPriceHistogram.vue?vue&type=script&lang=js&"
export * from "./ClosingPriceHistogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports